import { NodeModel } from '@minoru/react-dnd-treeview';
import { DisassociateBusinessUnitModel } from '../../models/disassociate/businessUnit.model';
import {
    InterruptionModel,
    InterruptionsListModel,
} from '../../models/interruptions/interruptionList.model';
import {
    WorkshiftSchedulingModel,
    WorkshiftsListModel,
} from '../../models/workshifts/workshif-scheduling/workshiftSchedulingList.model';
import { getChildNodes, getDatesBetweenDates } from '../../utils';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    interruptionList: InterruptionsListModel;
    workshiftShedulingList: WorkshiftsListModel;
    openDisassociatedBusinessUnitsModal: (
        initDate: string,
        lastDate: string,
        employee: NodeModel[],
        listToDelete: DisassociateBusinessUnitModel[]
    ) => void;
    getInterruptionsList: (
        startDate: string,
        endDate: string,
        employeeID: string | number,
        interruptionList: InterruptionsListModel
    ) => InterruptionModel[];
    getWorkshiftScheduling: (
        date: string | number,
        employeeID: string | number,
        workshiftShedulingList: WorkshiftsListModel
    ) => WorkshiftSchedulingModel | undefined;
};

export const controllerDisassociatedBusinessUnitsModal = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    interruptionList,
    workshiftShedulingList,
    openDisassociatedBusinessUnitsModal,
    getInterruptionsList,
    getWorkshiftScheduling,
}: Props) => {
    let row1 = grid.selectedRanges[0].row;
    let row2 = grid.selectedRanges[0].row2;
    let col1 = grid.selectedRanges[0].col - 2;
    let col2 = grid.selectedRanges[0].col2 - 2;

    if (row1 > row2) {
        let aux = row1;
        row1 = row2;
        row2 = aux;
    }

    if (col1 > col2) {
        let aux = col1;
        col1 = col2;
        col2 = aux;
    }

    let initDate = getDatesBetweenDates(startDate, endDate)[col1];
    let lastDate = getDatesBetweenDates(startDate, endDate)[col2];

    let selectedEmployees = getChildNodes(treeEmployees).slice(row1, row2 + 1);

    let dates = getDatesBetweenDates(initDate, lastDate);

    let workshifts: WorkshiftSchedulingModel[] = [];

    for (let emp = 0; emp < selectedEmployees.length; emp++) {
        for (let date = 0; date < dates.length; date++) {
            let workshiftId = getWorkshiftScheduling(
                dates[date],
                selectedEmployees[emp].id,
                workshiftShedulingList
            );
            if (workshiftId) {
                workshifts.push(workshiftId);
            }
        }
    }

    let interruptions: InterruptionModel[] = [];

    for (let emp = 0; emp < selectedEmployees.length; emp++) {
        let interruption = getInterruptionsList(
            initDate,
            lastDate,
            selectedEmployees[emp].id,
            interruptionList
        );

        interruption.forEach((interr) => {
            interruptions.push(interr);
        });
    }

    let listToDelete: DisassociateBusinessUnitModel[] = [];

    dates.forEach((date) => {
        workshifts.forEach((w) => {
            let workshift: DisassociateBusinessUnitModel = {
                id: w.businessUnit?.id ?? -1,
                businessUnit: w.businessUnit,
                date: w.date.split('T')[0],
                employeeID: w.employeeId,
                employee: selectedEmployees.find((e) => e.id == w.employeeId)?.text,
            };

            if (
                date == w.date.split('T')[0] &&
                !listToDelete.includes(workshift) &&
                workshift.businessUnit
            ) {
                listToDelete.push(workshift);
            }
        });
    });

    dates.forEach((date) => {
        interruptions.forEach((i) => {
            let interruption: DisassociateBusinessUnitModel = {
                id: i.businessUnit?.id ?? -1,
                businessUnit: i.businessUnit,
                date: i.startDate.split('T')[0],
                employeeID: i.employeeId,
                employee: selectedEmployees.find((e) => e.id == i.employeeId)?.text,
            };

            if (
                date == i.startDate.split('T')[0] &&
                !listToDelete.includes(interruption) &&
                interruption.businessUnit
            ) {
                listToDelete.push(interruption);
            }
        });
    });

    if (
        initDate &&
        lastDate &&
        selectedEmployees.length > 0 &&
        listToDelete.length > 0
    ) {
        openDisassociatedBusinessUnitsModal(
            initDate,
            lastDate,
            selectedEmployees,
            listToDelete
        );
    }
};
